import { useCallback, useMemo, useRef } from 'react';
import { useTheme } from 'styled-components';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import 'flatpickr/dist/themes/dark.css';

import ClockIcon from '@/core/components/Icons/svg/clock.svg';

import {
  TimePickerCalendarContainer,
  TimePickerIcon,
  TimePickerInputWrapper,
} from './TimePicker.styles';
import type { TimePickerProps } from './TimePicker.types';

export const TimePicker = ({ value, onChange, placeholder = '--:--' }: TimePickerProps) => {
  const calendarContainerRef = useRef<HTMLDivElement | null>(null);
  const theme = useTheme();

  const options = useMemo(
    () => ({
      enableTime: true,
      noCalendar: true,
      dateFormat: 'H:i',
      time_24hr: true,
      allowInput: false,
      appendTo:
        typeof document !== 'undefined' ? calendarContainerRef.current ?? document.body : undefined,
      theme: theme.theme,
    }),
    [theme.theme]
  );

  const handleChange = useCallback(
    (_dates: Array<Date>, dateStr: string) => {
      onChange(dateStr);
    },
    [onChange]
  );

  const flatpickrValue = value && /^\d{1,2}:\d{2}$/.test(value) ? value : undefined;

  return (
    <>
      <TimePickerCalendarContainer
        ref={calendarContainerRef}
        aria-hidden
      />
      <TimePickerInputWrapper>
        <Flatpickr
          key={`timepicker-${theme.theme}`}
          value={flatpickrValue}
          onChange={handleChange}
          options={options}
          placeholder={placeholder}
        />
        <TimePickerIcon>
          <ClockIcon
            width={18}
            height={18}
          />
        </TimePickerIcon>
      </TimePickerInputWrapper>
    </>
  );
};
